import React from 'react';
import { navigate } from '@reach/router';

import { DataGrid } from '@material-ui/data-grid';

const ClientOrganizationsGrid = ({ rows, pageSize = 10 }) => {

    const columns = [
        { field: 'name', headerName: 'Name', width: 300 },
        { field: 'phoneNumber', headerName: 'Phone', width: 200 },
        { field: 'address', headerName: 'Address', width: 500 },
        { field: 'jurisdiction', headerName: 'Jurisdiction', width: 150 },
        
    ];

    const handleCellClick = (event) => {
        if (event.field === 'name') {
            navigate(`/admin/organization/${event.row.id}`);
        }
    }

    return (
        <div style={{height: 700, width: '100%'}}>
            <DataGrid rows={rows} columns={columns} pageSize={pageSize} onCellClick={handleCellClick} />
        </div>
    )
};

export default ClientOrganizationsGrid;